import { render } from "./Sidebar.vue?vue&type=template&id=cc57be62&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=cc57be62&scoped=true&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=cc57be62&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc57be62"]])

export default __exports__